import { Component, Input } from "@angular/core";
import { SourceMetadata } from "../../models/Metadata";

@Component({
    selector: "metadata-modal-item",
    templateUrl: "./metadatamodalitem.component.html",
    standalone: false
})

export class MetadataModalItemComponent {
    @Input() metadataItem!: SourceMetadata;
    public visible: boolean = false;

    /*
     * Toggle content visible/invisible
     */
    toggle(): void {
        this.visible = !this.visible;
    }
}

